import { Brick, registerBrick } from 'olympe';
import { fromBase64 } from '@olympeio/core';

export default class SimpleDecrypt extends Brick {

    /**
     * @protected
     * @param {!BrickContext} context
     * @param {string} encryptedText
     * @param {string} cipherKey
     * @param {function(string)} setPlainText
     */
    update(context, [encryptedText, cipherKey], [setPlainText]) {
        if (!cipherKey || typeof cipherKey !== 'string') {
            console.error('cipherKey is not a valid string!');
            return;
        }
        if (!encryptedText || typeof encryptedText !== 'string') {
            console.error('encryptedText is not a valid string!');
            return;
        }

        const encryptedBinary = new Uint16Array(fromBase64(encryptedText));

        let fullKey = cipherKey;
        // Repeat the key so that it covers all the plain text's length
        while (fullKey.length < encryptedBinary.length) {
            fullKey += cipherKey;
        }

        let result = '';
        // For each character in the EncryptedText, perform a XOR op with the key
        for (let i = 0; i < encryptedBinary.length; i++) {
            result += String.fromCharCode(encryptedBinary[i] ^ fullKey.charCodeAt(i));
        }

        setPlainText(result);
    }
}

registerBrick('0178162bf8860ef66aab', SimpleDecrypt);
